import FilterBoxAnimated from './filter_box_animated';

export default FilterBoxAnimated;
